const IScroll = require("iscroll");
const $ = require("jquery");
require("jquery-drawer");

$(".drawer").drawer();
